var module = angular.module('octopusApp.shared');

module.directive('tagList', function () {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      tags: '='
    },
    template: '<span class="label label-info" ng-class="label" ng-repeat="tag in tags | csvToArray">{{ tag }}</span> ',
    link: function (scope, element, attrs) {
      scope.label = "label-info";
    }
  };
});

module.directive('environmentList', function () {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      tags: '='
    },
    template: '<span class="label" ng-class="label" ng-repeat="tag in tags | csvToArray">{{ tag }}</span> ',
    link: function (scope, element, attrs) {
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/directives/tag_list.js
// module id = 6918435214415251
// module chunks = 1